import { SelectionItem } from "@/forms/ViewModelFormTypes";
import { StockTaking } from "../services/StockTakingGraphQLService";

export class StockTakingOverviewViewModel {
  public itemsPerPage = 25;
  public search = "";

  public storeFilter: {
    selected: string[];
    items: SelectionItem[];
  } = {
    selected: [],
    items: []
  };

  public headers = [
    { text: "Datum", value: "date" },
    { text: "Lager", value: "store.name" }
  ];
  public items: StockTaking[] = [];
  public totalItems = 0;
  public options = {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: this.itemsPerPage,
    multiSort: true,
    mustSort: false,
    sortBy: [],
    sortDesc: []
  };
  public loading = true;
  public pageNumber = 1;
}
